import type { ReactNode } from 'react';
import { ShoppingCart } from 'lucide-react';

import type {
  FundTransactionDetail,
  ReconciliationStateResponse,
} from '@/types/fund-transactions';

import { renderFields, resolveEyebrow, toView } from './assetSaleDetails';
import { TransactionDetailsCard } from './TransactionDetailsCard';

export function PurchaseDetailsCard({
  transaction,
  fundName,
  reconciliation,
  onViewJournalEntries,
  descriptionAside,
}: {
  transaction: FundTransactionDetail;
  fundName: string;
  reconciliation: ReconciliationStateResponse | undefined;
  onViewJournalEntries?: () => void;
  descriptionAside: ReactNode;
}) {
  const view = toView(transaction.asset_sale);
  const companyHref =
    view?.portfolioCompanyId && transaction.captable_transaction_id
      ? `/app/portfolio/${view.portfolioCompanyId}/asset-transactions/${transaction.captable_transaction_id}`
      : null;

  return (
    <TransactionDetailsCard
      transaction={transaction}
      fundName={fundName}
      reconciliation={reconciliation}
      onViewJournalEntries={onViewJournalEntries}
      descriptionAside={descriptionAside}
      icon={<ShoppingCart className="h-5 w-5" />}
      iconClassName="bg-emerald-100 text-emerald-600 dark:bg-emerald-950/40 dark:text-emerald-300"
      eyebrow={resolveEyebrow(view, 'Investment Purchase')}
      fields={renderFields(view, transaction.currency, companyHref, {
        showRealizedGainLoss: false,
      })}
    />
  );
}
